import { createElement, forwardRef } from "react";
import { m, useReducedMotion } from "framer-motion";
import { imageReveal, viewport } from "../../../utils/motionVariants";
import { getMotionComponent, resolveTag } from "./motionPrimitives";

/**
 * Opacity + scale reveal for image containers. One observer per wrapper.
 */
const ImageReveal = forwardRef(function ImageReveal(
  { as = "div", className, children, viewport: viewportProp, ...props },
  ref
) {
  const reduceMotion = useReducedMotion();
  const tag = resolveTag(as);

  if (reduceMotion) {
    return createElement(tag, { ref, className, ...props }, children);
  }

  const Component = getMotionComponent(m, tag);

  return createElement(
    Component,
    {
      ref,
      initial: "hidden",
      whileInView: "visible",
      viewport: viewportProp ?? viewport,
      variants: imageReveal,
      className,
      ...props,
    },
    children
  );
});

ImageReveal.displayName = "ImageReveal";

export default ImageReveal;
